import type { IconProps } from '../types/IconProps.ts';
export const PhoneCall: IconProps = {
    name: 'PhoneCall',
    children: [
        `<path d="M7.5 2.5H3.3a.95.95 0 0 0-.95.8C1.3 10.14 4.98 20.1 20.91 21.9a1 1 0 0 0 1.09-1v-5a1 1 0 0 0-.91-1l-4.26-.38a1 1 0 0 0-.61.14l-2.13 1.28a.2.2 0 0 1-.18 0 18.5 18.5 0 0 1-6.53-5.45l-.29-.38a.2.2 0 0 1 0-.24l1.21-1.6a1 1 0 0 0 .2-.6V3.5a1 1 0 0 0-1-1M13 6c2.59-.52 5 1.46 5 4.1v.9M14 2h1a7 7 0 0 1 7 7v2" />`,
    ]
};